import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Admin from "./pages/Admin";
import Review from "./pages/Review";
import Done from "./pages/Done";
import Expired from "./pages/Expired";
import NotFound from "./pages/NotFound";
import AuthInvalid from "./pages/AuthInvalid";
import AuthUsed from "./pages/AuthUsed";
import AuthExpired from "./pages/AuthExpired";

export default function App() {
  return (
    <div className="min-h-screen">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/review/:token" element={<Review />} />
        <Route path="/done" element={<Done />} />
        <Route path="/expired" element={<Expired />} />
        <Route path="/auth/invalid" element={<AuthInvalid />} />
        <Route path="/auth/used" element={<AuthUsed />} />
        <Route path="/auth/expired" element={<AuthExpired />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}
